import React from 'react';

const Thanks = () => {
	return (
		<div className="thanks">
			<h1 className="thanks__header">
				Thanks for the message! I'll get back to you shortly!
			</h1>
		</div>
	);
};

export default Thanks;



// WEBPACK FOOTER //
// ./src/components/Thanks.js